<template>
  <div class="container-fluid">
    <div class="page-title">
      <i class="fa-regular fa-map"></i>
      <h1>{{ $t("COMMON.CLIENTS") }}</h1>
    </div>
    <div class="page-wrapper">
      <div slot="header" class="page-wrapper-header">
        <div class="row">
          <div class="col-6">
            <h3 class="mb-0">{{ $t("CLIENTS.CLIENTS_LIST") }}</h3>
          </div>
          <div class="col-6 text-right">
            <base-button
              class="elite-button add"
              icon
              size="sm"
              @click="openClientCreateModal"
              v-if="$currentUserCan($permissions.PERM_CREATE_CLIENTS)"
            >
              <span class="btn-inner--icon">
                <i class="far fa-plus-circle"></i>
              </span>
              <span class="btn-inner--text">{{
                $t("CLIENTS.ADD_CLIENT")
              }}</span>
            </base-button>
            <!--<notification-subscription
              v-if="$currentUserCan($permissions.PERM_VIEW_CLIENTS)"
              :objectType="'clients'"
              :events="{
                CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
              }"
            />-->
          </div>
        </div>
      </div>

      <client-list-table
        @onViewClient="openClientViewModal"
        @onEditClient="openClientEditModal"
        @onDeleteClient="deleteClient"
        :key="renderKey * 100"
      />

      <div
        v-if="isViewClientModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isViewClientModalOpened ? 'show' : 'hide']"
        :key="renderKey * 200"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'CLIENT'"
          @onCloseModal="closeClientModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("CLIENTS.VIEW_CLIENT") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <notification-subscription
                v-if="openClient"
                :objectType="'clients'"
                :objectId="openClient.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  class="edit"
                  @click="openClientEditModal(openClient)"
                >
                  <i class="fal fa-edit"></i>
                  <span>{{ $t("COMMON.EDIT") }}</span>
                </button>
                <button class="delete" @click="deleteClient(openClient)">
                  <i class="fal fa-trash-alt"></i>
                  <span>{{ $t("COMMON.DELETE") }}</span>
                </button>
              </base-dropdown>
              <button class="close" @click="closeClientModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <view-client-page
              v-if="openClient"
              :clientId="openClient.id"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isEditClientModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isEditClientModalOpened ? 'show' : 'hide']"
        :key="renderKey * 300"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'CLIENT'"
          @onCloseModal="closeClientModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("CLIENTS.EDIT_CLIENT") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <base-dropdown
                title-classes="btn dropdown-button"
                menu-on-right
                :has-toggle="false"
              >
                <template slot="title">
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <button
                  class="view"
                  @click="openClientViewModal(openClient)"
                >
                  <i class="fal fa-expand-alt"></i>
                  <span>{{ $t("COMMON.VIEW") }}</span>
                </button>
              </base-dropdown>
              <button
                class="close"
                @click="openClientViewModal(openClient)"
              >
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <edit-client-page
              v-if="openClient"
              :clientId="openClient.id"
              @onViewClient="openClientViewModal"
            />
          </div>
        </div>
      </div>

      <div
        v-if="isAddClientModalOpened"
        class="resizable-wrapper"
        v-bind:class="[isAddClientModalOpened ? 'show' : 'hide']"
        :key="renderKey * 400"
      >
        <div
          class="resizable-wrapper-content"
          v-resizable-modal="'CLIENT'"
          @onCloseModal="closeClientModal(true, true)"
        >
          <div class="resizable-wrapper-content-header">
            <div class="resizable-wrapper-content-header-left">
              <h1>
                {{ $t("CLIENTS.ADD_CLIENT") }}
              </h1>
            </div>
            <div class="resizable-wrapper-content-header-right">
              <button class="close" @click="closeClientModal(true)">
                <i class="fal fa-times"></i>
              </button>
            </div>
          </div>
          <div class="resizable-wrapper-content-body">
            <add-client-page @onViewClient="openClientViewModal" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Button } from "element-ui";
import requestErrorMixin from "@/mixins/request-error-mixin";
import {
  QUERY_ACTIONS_VIEW,
  QUERY_ACTIONS_EDIT,
  QUERY_ACTIONS_ADD,
} from "@/constants/common";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import ClientListTable from "./partials/ClientListTable.vue";
import EditClientPage from "./components/EditClientComponent.vue";
import AddClientPage from "./components/AddClientComponent.vue";
import ViewClientPage from "./components/ViewClientComponent.vue";

export default {
  layout: "DashboardLayout",

  components: {
    ClientListTable,
    NotificationSubscription,
    EditClientPage,
    AddClientPage,
    ViewClientPage,
    [Button.name]: Button,
  },

  mixins: [requestErrorMixin],

  computed: {},

  watch: {},

  data() {
    const clientId = this.$route.query.id;
    const action = this.$route.query.action;
    let isViewClientModalOpened = false;
    let isEditClientModalOpened = false;
    let isAddClientModalOpened = false;
    let openClient = null;
    if (clientId && action) {
      if (action === QUERY_ACTIONS_VIEW) {
        isViewClientModalOpened = true;
      } else if (action === QUERY_ACTIONS_EDIT) {
        isEditClientModalOpened = true;
      }
      openClient = { id: clientId };
    } else if (action === QUERY_ACTIONS_ADD) {
      isAddClientModalOpened = true;
    }
    return {
      isViewClientModalOpened: isViewClientModalOpened,
      isEditClientModalOpened: isEditClientModalOpened,
      isAddClientModalOpened: isAddClientModalOpened,
      openClient: openClient,
      renderKey: 1,
    };
  },

  methods: {
    openClientCreateModal() {
      this.closeClientModal();
      this.isAddClientModalOpened = true;

      this.$router.replace({
        name: "List Clients",
        query: { action: QUERY_ACTIONS_ADD },
      });
    },
    openClientViewModal(client, reRender = false) {
      this.closeClientModal();
      this.openClient = client;
      this.isViewClientModalOpened = true;
      if (reRender) {
        this.renderKey++;
      }

      this.$router.replace({
        name: "List Clients",
        query: { id: this.openClient.id, action: QUERY_ACTIONS_VIEW },
      });
    },
    openClientEditModal(client) {
      this.closeClientModal();
      this.openClient = client;
      this.isEditClientModalOpened = true;

      this.$router.replace({
        name: "List Clients",
        query: { id: this.openClient.id, action: QUERY_ACTIONS_EDIT },
      });
    },
    closeClientModal(goBack = false, grid = false) {
      if (goBack && this.$store.getters["routes/previousPathRoute"]) {
        if (grid) {
          this.$store.dispatch("routes/goBackToPreviousGrid");
        } else {
          this.$store.dispatch("routes/goToPreviousPath");
        }
        return;
      }
      this.isAddClientModalOpened = false;
      this.isViewClientModalOpened = false;
      this.isEditClientModalOpened = false;
      this.openClient = null;

      if (
        this.$route.name !== "List Clients" ||
        JSON.stringify(this.$route.query) !== JSON.stringify({})
      ) {
        this.$router
          .replace({
            name: "List Clients",
            query: {},
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }
    },

    async deleteClient(client) {
      const confirmation = await swal.fire({
        title: this.$t("CLIENTS.DELETE_THIS_CLIENT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.isConfirmed) {
          await this.$store.dispatch("clients/destroy", client.id);
          this.renderKey++;
          this.closeClientModal();
          this.$notify({
            type: "success",
            timeout: 3000,
            message: this.$t("CLIENTS.CLIENT_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },
};
</script>
